// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-user-round.js';

import { paths } from '../generated/circle-user-round';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-user-round', Original, paths);
